import { jsx as n, Fragment as _ } from "react/jsx-runtime";
import { c as l } from "./index-SYE1cn5_.js";
const c = "_spinner_lkc6l_1", m = "_spin_lkc6l_1", s = {
  spinner: c,
  spin: m,
  "spinner--xs": "_spinner--xs_lkc6l_9",
  "spinner--sm": "_spinner--sm_lkc6l_14",
  "spinner--md": "_spinner--md_lkc6l_19",
  "spinner--lg": "_spinner--lg_lkc6l_23"
}, a = ({
  children: r,
  size: e = "sm",
  loading: p = !0,
  className: i
}) => p ? /* @__PURE__ */ n(
  "span",
  {
    className: l(
      s.spinner,
      s[`spinner--${e}`],
      i
    )
  }
) : /* @__PURE__ */ n(_, { children: r });
export {
  a as S
};
